import { InteractionOverlaySettings } from '$/GraphQL/schema/types';

import { InteractionInfo, OverlayDimensions } from '$/components/Interactions/InteractionInfo';

export const useInVideoRegistrationCalcDimensions = (
  _interaction: InteractionInfo,
  playerWidth: number,
  playerHeight: number,
  _settings?: InteractionOverlaySettings | null
): OverlayDimensions => {
  return {
    x: playerWidth / 2,
    y: playerHeight * 0.05,
    playerWidth,
    playerHeight,
    dynamicSize: true,
  };
};
